import { AgentMessage } from '../../../../types/AgentMessage';
import { Button } from '../../../cdl/Button/Button';
import { useDrawer } from '../../../cdl/Drawer/useDrawer.hook';
import { translate } from '../../../common/helpers/translate.helper';
import { UpdateAgentForm } from '../../UpdateAgentForm';

interface EditAgentButtonProps {
    agent: AgentMessage;
}

export const EditAgentButton = ({ agent }: EditAgentButtonProps) => {
    const { push, pop } = useDrawer();

    const openPortEditModal = () => {
        const drawerId = push({
            header: { title: translate('agents.editAgent') },
            content: <UpdateAgentForm agentId={agent.id} onSuccess={() => pop(drawerId)} />,
        });
    };

    return (
        <Button emphasis="high" onClick={openPortEditModal}>
            {translate('actions.edit')}
        </Button>
    );
};
